module.exports = __webpack_public_path__ + "media/notification-tone-swift-gesture.e4ee8368.mp3";